module.exports = __webpack_public_path__ + "76aa21ae.png";